import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateGlobalExclusions = document.createElement('template');

templateGlobalExclusions.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
     ${/* TBD: gz-grid-view */ ''}
      <div class="content">
            <div class="grid">
                <gz-grid-view class="grid-view">
                    <div class="header-buttons" slot="grid-header-actions-slot">
                        <gz-button id="addExclusions"></gz-button>
                        <gz-button id="assignToLists" type="quiet" color="secondary" buttonfontsize="medium"></gz-button>
                        <gz-button id="exportSelection" type="quiet" color="secondary" buttonfontsize="medium"></gz-button>
                        <gz-button id="deleteExclusions" type="outline" color="negative" buttonfontsize="medium"></gz-button>
                    </div>
                </gz-grid-view>
            </div>
      </div>
  </div>

`;
